var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseNavy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22703 0.785645L5.86835 4.14432L2.51028 0.785645L0.368652 2.92727L3.72672 6.28655L0.368652 9.64523L2.51028 11.7869L5.86835 8.42818L9.22703 11.7869L11.3687 9.64523L8.00998 6.28655L11.3687 2.92727L9.22703 0.785645Z",
    fill: "#282B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22703 0.785645L5.86835 4.14432L2.51028 0.785645L0.368652 2.92727L3.72672 6.28655L0.368652 9.64523L2.51028 11.7869L5.86835 8.42818L9.22703 11.7869L11.3687 9.64523L8.00998 6.28655L11.3687 2.92727L9.22703 0.785645Z",
    fill: "black",
    fillOpacity: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseNavy);
export default __webpack_public_path__ + "static/media/icon-close-navy.d181b1f6ed0ee562113d03fffa60cda4.svg";
export { ForwardRef as ReactComponent };